module.exports = __webpack_public_path__ + "media/Niki_bez_audia.e0e009df.mp4";